import React, { Component } from 'react'

class ButtonToolbar extends Component {
  render () {
    return (
      <div className='btn-toolbar'>
        {this.props.children}
      </div>
    )
  }
}
export default ButtonToolbar



// WEBPACK FOOTER //
// ./src/components/basic/containers/ButtonToolbar.js